/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { InputTextModule } from 'primeng/inputtext';
import { SliderModule } from 'primeng/slider';
import { SliderWithTextInput } from '../../../models/inputs/slider-with-textbox-input';
import { BaseInputComponent } from '../base-input/base-input.component';

@Component({
    selector: 'lib-slider-with-textbox-input',
    standalone: true,
    imports: [InputTextModule, FormsModule, ReactiveFormsModule, TranslateModule, SliderModule],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SliderWithTextInputComponent),
            multi: true
        }
    ],
    template: `
        <input
            id="{{ 'input' + name }}"
            class="form-control mb-3"
            [class]="control.inputClass.join(' ')"
            pInputText
            type="number"
            [min]="control.min"
            [max]="control.max"
            [step]="control.step"
            [disabled]="disabled"
            [placeholder]="control.placeholder | translate"
            [value]="value"
            (input)="onInputChange($event)"
            (blur)="onTouched()"
        />
        <p>{{ control.defaultValueLabel | translate }}: {{ control.default }}</p>
        <p-slider
            [(ngModel)]="value"
            [disabled]="disabled"
            [min]="control.min"
            [max]="control.max"
            [step]="control.step"
            (onSlideEnd)="onSliderChange($event)"
            (blur)="onTouched()"
            class="mt-2"
        >
        </p-slider>
    `
})
export class SliderWithTextInputComponent extends BaseInputComponent implements ControlValueAccessor {
    @Input() name!: string;
    @Input() override control!: SliderWithTextInput;

    value!: number;
    disabled = false;

    onChange: (_: number) => void = () => {};
    onTouched: () => void = () => {};

    writeValue(obj: number): void {
        if (obj !== undefined && obj !== null) {
            this.value = obj;
        }
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    onInputChange(event: Event): void {
        const target = event.target as HTMLInputElement;
        const newValue = target.value;
        let parsed = parseFloat(newValue);

        if (!isNaN(parsed)) {
            // Validazione min/max se presenti
            if (this.control.min !== undefined && parsed < this.control.min) {
                parsed = this.control.min;
            }
            if (this.control.max !== undefined && parsed > this.control.max) {
                parsed = this.control.max;
            }

            // Arrotonda al valore più vicino di step se definito
            if (this.control.step !== undefined && this.control.step > 0) {
                const nearestStep = Math.round(parsed / this.control.step) * this.control.step;
                // Assicurati che il valore arrotondato sia all'interno dei limiti min/max
                parsed = nearestStep;
                if (this.control.min !== undefined && parsed < this.control.min) {
                    parsed = this.control.min;
                }
                if (this.control.max !== undefined && parsed > this.control.max) {
                    parsed = this.control.max;
                }
            }

            this.value = parsed;
            this.onChange(this.value);
            this.writeValue(this.value);
        }
    }
    onSliderChange(event: any): void {
        if (event && event.value !== undefined) {
            this.value = event.value;
            this.onChange(this.value);
        }
    }
}
